import { PortableTextBlock } from '@portabletext/react';

import { GatsbyImg } from 'components';
import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { GetKOHOBtn } from 'components/rebrand/GetKOHOBtn';

import { IQueryParams, ISanityImage, ITrackEventProps } from 'typescriptDefs';

interface Props {
  data: {
    heroContent: PortableTextBlock | PortableTextBlock[];
    heroImg: ISanityImage;
    heroImgAltText: string;
    btnText: string;
    tracking: { queryParams: IQueryParams; trackEventProps: ITrackEventProps };
  };
}

const Hero = ({ data: { btnText, heroContent, heroImg, heroImgAltText, tracking } }: Props) => {
  return (
    <Section>
      <Container className="grid items-center gap-64 px-32 pb-64 pt-40 md:grid-cols-2 md:gap-32 md:px-[unset] md:pb-96 md:pt-64">
        <div>
          <div className="mb-24 text-center md:text-left [&_h1]:text-primary-400 last-of-type:[&_h1]:mb-24 [&_h1_strong]:text-primary-200 md:[&_p]:w-[80%]">
            <CustomPortableText content={heroContent} />
          </div>
          <GetKOHOBtn
            buttonLocation={tracking.trackEventProps.label ?? ''}
            queryParams={tracking.queryParams}
            trackEventProps={tracking.trackEventProps}
            buttonClassName="w-full md:w-auto"
          >
            {btnText}
          </GetKOHOBtn>
        </div>
        <div>
          <div className="overflow-hidden rounded-16">
            <GatsbyImg alt={heroImgAltText} image={heroImg.asset.gatsbyImageData} />
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Hero;
